export default __webpack_public_path__ + "static/media/logoFbhRes.e987eafc.png";